import React, {useContext, ReactNode} from 'react'
import {RuleBuilderStepsProps} from '../types'

interface RuleBuilderStepsContextValue extends RuleBuilderStepsProps {
  activeStep: number
  isError?: boolean
  isLoading?: boolean
  clickable?: boolean
}

const RuleBuilderStepsContext = React.createContext<RuleBuilderStepsContextValue>({
  activeStep: 0
})
export const useRuleBuilderStepsContext = () => useContext(RuleBuilderStepsContext)

interface StepsProviderProps {
  value: RuleBuilderStepsContextValue
  children: ReactNode
}

export const RuleBuilderStepsProvider = ({value, children}: StepsProviderProps) => {
  const isError = value.state === 'error'
  const isLoading = value.state === 'loading'
  return (
    <RuleBuilderStepsContext.Provider value={{...value, isError, isLoading}}>
      {children}
    </RuleBuilderStepsContext.Provider>
  )
}
